import { PagedResponse } from "../../entities/common";
import {
  InvestmentMatchReviewCreateOtherCompanyRequest,
  InvestmentMatchReviewCreateOtherCompanyResult,
  InvestmentMatchReviewGroup,
  InvestmentMatchReviewGroupDto,
  InvestmentMatchReviewIgnoreRequest,
  InvestmentMatchReviewIgnoreResult,
  InvestmentMatchReviewQueueSummary,
  InvestmentMatchReviewRequest,
  InvestmentMatchReviewResolutionRequest,
  InvestmentMatchReviewResolutionResult,
  InvestmentMatchReviewTargetSearchRequest,
  InvestmentMatchReviewTargetSearchResult,
} from "../../entities/investmentReview";
import { defaultPagination, getPaginationFromMeta } from "../pagination";
import { apiSlice, TagTypes } from "./apiSlice";

const reviewTag = { type: TagTypes.InvestmentMatchReview as any, id: "QUEUE" };
const targetTag = { type: TagTypes.InvestmentMatchReview as any, id: "TARGETS" };

export const investmentReviewApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInvestmentReviewQueue: builder.query<PagedResponse<InvestmentMatchReviewGroup>, InvestmentMatchReviewRequest>({
      query: (request) => ({
        url: "/InvestmentMatchReview/queue",
        params: request,
      }),
      transformResponse: (response: InvestmentMatchReviewGroupDto[], meta): PagedResponse<InvestmentMatchReviewGroup> => ({
        items: response.map((group) => ({
          ...group,
          id: `${group.family}:${group.normalizedTitle}`,
        })),
        pagination: getPaginationFromMeta(meta) ?? defaultPagination(response.length),
      }),
      providesTags: [reviewTag],
    }),

    getInvestmentReviewQueueSummary: builder.query<InvestmentMatchReviewQueueSummary, InvestmentMatchReviewRequest>({
      query: (request) => ({
        url: "/InvestmentMatchReview/queue-summary",
        params: request,
      }),
      providesTags: [reviewTag],
    }),

    searchInvestmentReviewTargets: builder.query<InvestmentMatchReviewTargetSearchResult, InvestmentMatchReviewTargetSearchRequest>({
      query: (request) => ({
        url: "/InvestmentMatchReview/targets",
        params: request,
      }),
      providesTags: [targetTag],
    }),

    resolveInvestmentReviewGroup: builder.mutation<InvestmentMatchReviewResolutionResult, InvestmentMatchReviewResolutionRequest>({
      query: (body) => ({
        url: "/InvestmentMatchReview/resolve",
        method: "POST",
        body,
      }),
      invalidatesTags: [reviewTag, targetTag],
    }),

    createInvestmentReviewOtherCompany: builder.mutation<
      InvestmentMatchReviewCreateOtherCompanyResult,
      InvestmentMatchReviewCreateOtherCompanyRequest
    >({
      query: (body) => ({
        url: "/InvestmentMatchReview/create-other-company",
        method: "POST",
        body,
      }),
      invalidatesTags: [reviewTag, targetTag],
    }),

    ignoreInvestmentReviewGroup: builder.mutation<InvestmentMatchReviewIgnoreResult, InvestmentMatchReviewIgnoreRequest>({
      query: (body) => ({
        url: "/InvestmentMatchReview/ignore",
        method: "POST",
        body,
      }),
      invalidatesTags: [reviewTag],
    }),
  }),
});

export const {
  useGetInvestmentReviewQueueQuery,
  useGetInvestmentReviewQueueSummaryQuery,
  useLazySearchInvestmentReviewTargetsQuery,
  useResolveInvestmentReviewGroupMutation,
  useCreateInvestmentReviewOtherCompanyMutation,
  useIgnoreInvestmentReviewGroupMutation,
} = investmentReviewApi;
